var cart = {
      
      update_quantities:function(product_id){
         var stock_information = $('#add_to_cart_form'+product_id).data('stock');
         $('.select-variation').each(function(){

            var k = 'color:'+$('input[name="color"]').val() + $(this).data('key') +':'+ $(this).data('value');
            
            if(typeof(stock_information[k]) !== 'undefined' ){

               $(this).attr('data-stock' , stock_information[k]);
            }

         });  
      },
      init:function(){
         
         var $this = this;

         $('body').append('<div class="cart-sidebar-overlay" onclick="cart.hide()"/>');

         $('.section-product-details .product-info').theiaStickySidebar({        
            additionalMarginTop: 30
         });  

         $('.select-variation').on('click',function(){
            var $this = $(this);
            var product_id =  $this.data('id');
            var value =  $this.data('value');
            var key   =  $this.data('key');

            if($this.hasClass('btn-selected')){
               $('.select-variation[data-key="'+key+'"]').removeClass('btn-selected');
               $('input[name="'+key+'"]').val(''); 
            }else{
               $('.select-variation[data-key="'+key+'"]').removeClass('btn-selected');
               $('input[name="'+key+'"]').val(value);          
               $this.addClass('btn-selected');
            }     

            cart.update_quantities(product_id);
                 
            return false;
         });
        
         
      },

      checkout:function(){

         var $this = this;

         $.extend({}, AjaxForms , {
            options:{
               stop_response:true,
               api_route : BASE_URL +'/orders',
               successFn:function(){
                  
                  var u = BASE_URL + '/'+CURRENT_LANGUAGE +'/thank-you';

                  if( $("#ajaxModal .modal-body:visible").length > 0 ){

                     $("#ajaxModal .modal-body").load( u + " #ajax-content .content-main" , function(){
                        
                        $('#ajaxModal').modal('show');         
                        initForm("#ajaxModal .modal-body");
                     
                     });

                     $this.refresh();

                  }else{

                     window.location = u;

                  }
               
               }

           }}).init('#checkout_step_1_form');

                   
      },

      quick_checkout : function(){
         var $this = this;
         $('.checkout-btn').on('click',function(){
               $.ajax({
                  type: "post", 
                  url: "/orders",
                  data: {action:'place-order'},
                  success:function(data){ 
                     var u = BASE_URL + '/'+CURRENT_LANGUAGE +'/thank-you';

                     $("#ajaxModal .modal-body").load( u + " #ajax-content .content-main" , function(){
                           
                        $('#ajaxModal').modal('show');         
                        initForm("#ajaxModal .modal-body");
                     
                     });

                     $this.hide();
                     
                     $this.refresh();
                  },
                  error:function(data){

                     actionResponseModal(data.responseJSON.error,'error','.actions-block .save'); 

                  }

               });
               return false;
            });
      },

       duplicate : function(id){
           var $this = this;
              $.ajax({
                  type: "post", 
                  url: "/orders/duplicate",
                  data: {
                     order_id:id
                  },
                  success:function(data){ 

                     $('#header_cart_total').html( parseFloat( data['order']['subtotal_amount'] ).toFixed(2) +' &euro;');
                     $('#dialog-confirm-'+id+' .close-modal').trigger('click');
                     actionResponseModal(data.message,'success','.actions-block .save'); 
                     $this.show();
                  },
                  error:function(data){

                     actionResponseModal(data.responseJSON.error,'error','.actions-block .save'); 

                  }

               });
               return false;
         
      },


      show:function(){
         var $this = this;

         load_partial($('[data-partial="checkout.checkout-sidebar"]') , function(){

            $('body').addClass('show-cart-sidebar');
            $this.quick_checkout();
         });

         if(  $('[data-partial="checkout.cart"]').length>0 ){

             load_partial($('[data-partial="checkout.cart"]'));
         }

      },

      hide:function(){
         $('body').removeClass('show-cart-sidebar');

      },

      refresh:function(){
         var $this = this;

         load_partial($('[data-partial="checkout.checkout-sidebar]') , function(){
            $this.quick_checkout();        
         });      

      },

      add:function($form){
        
         var $this = this;

         if($('.add_to_cart_form .required_variation[value=""]').length>0){
             actionResponseModal($('.add_to_cart_form .required_variation[value=""]').data('label'),'error'); 
         }else{
            
            $.ajax({
               type: "post", 
               url: "/orders",
               data: $($form).serialize(),
               success:function(data){ 
                 $('#header_cart_total').html( parseFloat( data['order']['subtotal_amount'] ).toFixed(2) +' &euro;');
                  $this.show();
               },
               error:function(data){

                  actionResponseModal(data.responseJSON.error,'error','.actions-block .save'); 

               }

            });
         }
         
         return false;

      },
 
      update:function(product_id , quantity , additionals){
         var $this = this;

         $.ajax({
            type: "PUT", 
            url: "/orders",
            data: { 
               product_id: product_id,  
               quantity: quantity,
               additionals : additionals
            },
            success:function(data){ 
              $('#header_cart_total').html( parseFloat( data['order']['subtotal_amount'] ).toFixed(2) +' &euro;');
               $this.show();          
            },
            error:function(){
               actionResponseModal(data.message,'error','.actions-block .save'); 
            }
         });
      },
     
      remove:function(product_id){
         
         var $this = this;

         $.ajax({
            type: "DELETE", 
            url: "/orders", 
            data: { 
               product_id: product_id
            },
            success:function(data){ 
               $('#header_cart_total').html( parseFloat( data['order']['subtotal_amount'] ) .toFixed(2) +' &euro;');
               $this.show();
            },
            error:function(){
               actionResponseModal(data.message,'error','.actions-block .save'); 
            }
         });
      },


      

   };
